@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(649_153_668)
public val Res.string.capacity_col_planned: StringResource by lazy {
      StringResource("string:capacity_col_planned", "capacity_col_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54850, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 76546, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47885, 40),
      ))
    }

@delegate:ResourceContentHash(-259_550_251)
public val Res.string.capacity_col_target: StringResource by lazy {
      StringResource("string:capacity_col_target", "capacity_col_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54895, 39),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 76607, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47926, 35),
      ))
    }

@delegate:ResourceContentHash(-1_062_744_002)
public val Res.string.capacity_days: StringResource by lazy {
      StringResource("string:capacity_days", "capacity_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54935, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 76667, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47962, 45),
      ))
    }

@delegate:ResourceContentHash(354_764_920)
public val Res.string.capacity_demand: StringResource by lazy {
      StringResource("string:capacity_demand", "capacity_demand", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 55064, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 76816, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48095, 31),
      ))
    }

@delegate:ResourceContentHash(-2_044_037_853)
public val Res.string.capacity_demand_detail: StringResource by lazy {
      StringResource("string:capacity_demand_detail", "capacity_demand_detail", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 54981, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 76717, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48008, 86),
      ))
    }

@delegate:ResourceContentHash(1_086_426_359)
public val Res.string.capacity_everyone_answered: StringResource by lazy {
      StringResource("string:capacity_everyone_answered", "capacity_everyone_answered", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 55108, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 76860, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48127, 86),
      ))
    }

@delegate:ResourceContentHash(555_195_283)
public val Res.string.capacity_excluded: StringResource by lazy {
      StringResource("string:capacity_excluded", "capacity_excluded", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 55409, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 77277, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48420, 65),
      ))
    }

@delegate:ResourceContentHash(958_198_743)
public val Res.string.capacity_excluded_detail: StringResource by lazy {
      StringResource("string:capacity_excluded_detail", "capacity_excluded_detail", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 55191, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 76975, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48214, 68),
      ))
    }

@delegate:ResourceContentHash(-1_196_920_398)
public val Res.string.capacity_excluded_employment: StringResource by lazy {
      StringResource("string:capacity_excluded_employment", "capacity_excluded_employment", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 55264, 76),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 77072, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48283, 80),
      ))
    }

@delegate:ResourceContentHash(2_130_165_803)
public val Res.string.capacity_excluded_owner: StringResource by lazy {
      StringResource("string:capacity_excluded_owner", "capacity_excluded_owner", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 55341, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 77189, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48364, 55),
      ))
    }

@delegate:ResourceContentHash(1_620_021_007)
public val Res.string.capacity_gap: StringResource by lazy {
      StringResource("string:capacity_gap", "capacity_gap", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 55623, 32),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 77567, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48622, 24),
      ))
    }

@delegate:ResourceContentHash(-1_495_046_119)
public val Res.string.capacity_gap_even: StringResource by lazy {
      StringResource("string:capacity_gap_even", "capacity_gap_even", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 55475, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 77371, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48486, 45),
      ))
    }

@delegate:ResourceContentHash(-1_520_446_699)
public val Res.string.capacity_gap_short: StringResource by lazy {
      StringResource("string:capacity_gap_short", "capacity_gap_short", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 55537, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 77469, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48532, 42),
      ))
    }

@delegate:ResourceContentHash(821_573_946)
public val Res.string.capacity_gap_spare: StringResource by lazy {
      StringResource("string:capacity_gap_spare", "capacity_gap_spare", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 55580, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 77520, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48575, 46),
      ))
    }

@delegate:ResourceContentHash(2_055_122_717)
public val Res.string.capacity_hours: StringResource by lazy {
      StringResource("string:capacity_hours", "capacity_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 55656, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 77608, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48647, 30),
      ))
    }

@delegate:ResourceContentHash(-633_128_874)
public val Res.string.capacity_how: StringResource by lazy {
      StringResource("string:capacity_how", "capacity_how", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 55687, 460),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 77647, 820),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48678, 376),
      ))
    }

@delegate:ResourceContentHash(-1_012_415_865)
public val Res.string.capacity_missing_title: StringResource by lazy {
      StringResource("string:capacity_missing_title", "capacity_missing_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 56148, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 78468, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49055, 62),
      ))
    }

@delegate:ResourceContentHash(751_729_355)
public val Res.string.capacity_no_request: StringResource by lazy {
      StringResource("string:capacity_no_request", "capacity_no_request", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 56207, 127),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 78543, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49118, 87),
      ))
    }

@delegate:ResourceContentHash(-1_879_187_953)
public val Res.string.capacity_norm: StringResource by lazy {
      StringResource("string:capacity_norm", "capacity_norm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 56452, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 78856, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49323, 41),
      ))
    }

@delegate:ResourceContentHash(1_887_083_130)
public val Res.string.capacity_norm_detail: StringResource by lazy {
      StringResource("string:capacity_norm_detail", "capacity_norm_detail", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 56335, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 78695, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49206, 116),
      ))
    }

@delegate:ResourceContentHash(561_006_310)
public val Res.string.capacity_people: StringResource by lazy {
      StringResource("string:capacity_people", "capacity_people", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 56490, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 78926, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49365, 31),
      ))
    }

@delegate:ResourceContentHash(2_085_680_073)
public val Res.string.capacity_person_absent: StringResource by lazy {
      StringResource("string:capacity_person_absent", "capacity_person_absent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 56526, 82),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 78970, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49397, 70),
      ))
    }

@delegate:ResourceContentHash(761_371_687)
public val Res.string.capacity_person_available: StringResource by lazy {
      StringResource("string:capacity_person_available", "capacity_person_available", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 56609, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 79077, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49468, 73),
      ))
    }

@delegate:ResourceContentHash(-753_833_934)
public val Res.string.capacity_person_no_target: StringResource by lazy {
      StringResource("string:capacity_person_no_target", "capacity_person_no_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 56679, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 79163, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49542, 45),
      ))
    }

@delegate:ResourceContentHash(-2_000_803_406)
public val Res.string.capacity_person_planned: StringResource by lazy {
      StringResource("string:capacity_person_planned", "capacity_person_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 56737, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 79253, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49588, 47),
      ))
    }

@delegate:ResourceContentHash(625_417_659)
public val Res.string.capacity_person_target: StringResource by lazy {
      StringResource("string:capacity_person_target", "capacity_person_target", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 56874, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 79430, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49709, 46),
      ))
    }

@delegate:ResourceContentHash(-1_130_349_367)
public val Res.string.capacity_person_target_month: StringResource by lazy {
      StringResource("string:capacity_person_target_month", "capacity_person_target_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 56793, 80),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 79321, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49636, 72),
      ))
    }

@delegate:ResourceContentHash(696_624_039)
public val Res.string.capacity_remind: StringResource by lazy {
      StringResource("string:capacity_remind", "capacity_remind", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 57305, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 80029, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50096, 43),
      ))
    }

@delegate:ResourceContentHash(890_736_467)
public val Res.string.capacity_reminder_message: StringResource by lazy {
      StringResource("string:capacity_reminder_message", "capacity_reminder_message", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 57043, 101),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 79663, 145),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49866, 93),
      ))
    }

@delegate:ResourceContentHash(1_829_118_911)
public val Res.string.capacity_reminder_message_due: StringResource by lazy {
      StringResource("string:capacity_reminder_message_due", "capacity_reminder_message_due", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 56925, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 79501, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49756, 109),
      ))
    }

@delegate:ResourceContentHash(-873_593_644)
public val Res.string.capacity_reminder_title: StringResource by lazy {
      StringResource("string:capacity_reminder_title", "capacity_reminder_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 57145, 87),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 79809, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49960, 75),
      ))
    }

@delegate:ResourceContentHash(600_942_218)
public val Res.string.capacity_reminders_sent: StringResource by lazy {
      StringResource("string:capacity_reminders_sent", "capacity_reminders_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 57233, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 79937, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50036, 59),
      ))
    }

@delegate:ResourceContentHash(-304_806_236)
public val Res.string.capacity_request_days: StringResource by lazy {
      StringResource("string:capacity_request_days", "capacity_request_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 57353, 113),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 80085, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50140, 105),
      ))
    }

@delegate:ResourceContentHash(-1_789_173_490)
public val Res.string.capacity_targets: StringResource by lazy {
      StringResource("string:capacity_targets", "capacity_targets", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 57567, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 80395, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50354, 48),
      ))
    }

@delegate:ResourceContentHash(1_642_496_812)
public val Res.string.capacity_targets_detail: StringResource by lazy {
      StringResource("string:capacity_targets_detail", "capacity_targets_detail", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 57467, 99),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 80235, 159),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50246, 107),
      ))
    }

@delegate:ResourceContentHash(-1_299_144_825)
public val Res.string.capacity_title: StringResource by lazy {
      StringResource("string:capacity_title", "capacity_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 57612, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 80472, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50403, 34),
      ))
    }

@delegate:ResourceContentHash(1_560_861_519)
public val Res.string.capacity_whole_month: StringResource by lazy {
      StringResource("string:capacity_whole_month", "capacity_whole_month", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 57655, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 80527, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50438, 44),
      ))
    }

@delegate:ResourceContentHash(-1_529_889_954)
public val Res.string.care_counter_child: StringResource by lazy {
      StringResource("string:care_counter_child", "care_counter_child", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 57704, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 80584, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50483, 62),
      ))
    }

@delegate:ResourceContentHash(1_771_588_130)
public val Res.string.care_counter_family: StringResource by lazy {
      StringResource("string:care_counter_family", "care_counter_family", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 57763, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 80655, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50546, 71),
      ))
    }

@delegate:ResourceContentHash(-1_651_717_140)
public val Res.string.care_counter_total: StringResource by lazy {
      StringResource("string:care_counter_total", "care_counter_total", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 57847, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 80755, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50618, 62),
      ))
    }

@delegate:ResourceContentHash(-524_460_955)
public val Res.string.care_for_child: StringResource by lazy {
      StringResource("string:care_for_child", "care_for_child", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 57910, 138),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 80826, 186),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50681, 114),
      ))
    }

@delegate:ResourceContentHash(-1_315_054_832)
public val Res.string.care_for_family: StringResource by lazy {
      StringResource("string:care_for_family", "care_for_family", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58049, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 81013, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50796, 51),
      ))
    }

@delegate:ResourceContentHash(1_836_509_798)
public val Res.string.care_for_label: StringResource by lazy {
      StringResource("string:care_for_label", "care_for_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58105, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 81085, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50848, 34),
      ))
    }

@delegate:ResourceContentHash(1_828_353_423)
public val Res.string.chart_full_size_title: StringResource by lazy {
      StringResource("string:chart_full_size_title", "chart_full_size_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58144, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 81132, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50883, 65),
      ))
    }

@delegate:ResourceContentHash(668_547_609)
public val Res.string.chart_hours_planned: StringResource by lazy {
      StringResource("string:chart_hours_planned", "chart_hours_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58214, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 81250, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50949, 39),
      ))
    }

@delegate:ResourceContentHash(-530_639_325)
public val Res.string.chart_hours_title: StringResource by lazy {
      StringResource("string:chart_hours_title", "chart_hours_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58258, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 81310, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50989, 45),
      ))
    }

@delegate:ResourceContentHash(59_019_836)
public val Res.string.chart_hours_worked: StringResource by lazy {
      StringResource("string:chart_hours_worked", "chart_hours_worked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58304, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 81364, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51035, 34),
      ))
    }

@delegate:ResourceContentHash(480_798_000)
public val Res.string.chart_labor_cost: StringResource by lazy {
      StringResource("string:chart_labor_cost", "chart_labor_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58351, 40),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 81427, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51070, 40),
      ))
    }

@delegate:ResourceContentHash(-51_957_788)
public val Res.string.chart_labor_share: StringResource by lazy {
      StringResource("string:chart_labor_share", "chart_labor_share", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58465, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 81617, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51168, 49),
      ))
    }

@delegate:ResourceContentHash(-959_385_960)
public val Res.string.chart_labor_share_income: StringResource by lazy {
      StringResource("string:chart_labor_share_income", "chart_labor_share_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58392, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 81500, 116),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51111, 56),
      ))
    }

@delegate:ResourceContentHash(723_604_969)
public val Res.string.chart_labor_trend_title: StringResource by lazy {
      StringResource("string:chart_labor_trend_title", "chart_labor_trend_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58531, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 81731, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51218, 67),
      ))
    }

@delegate:ResourceContentHash(-112_395_917)
public val Res.string.chart_plan_suffix: StringResource by lazy {
      StringResource("string:chart_plan_suffix", "chart_plan_suffix", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58607, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 81843, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51286, 33),
      ))
    }

@delegate:ResourceContentHash(-1_365_715_965)
public val Res.string.chart_revenue: StringResource by lazy {
      StringResource("string:chart_revenue", "chart_revenue", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58727, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 82019, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51398, 33),
      ))
    }

@delegate:ResourceContentHash(249_826_414)
public val Res.string.chart_revenue_labor_title: StringResource by lazy {
      StringResource("string:chart_revenue_labor_title", "chart_revenue_labor_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58641, 85),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 81885, 133),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51320, 77),
      ))
    }

@delegate:ResourceContentHash(-1_369_495_668)
public val Res.string.chart_show_full_size: StringResource by lazy {
      StringResource("string:chart_show_full_size", "chart_show_full_size", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58769, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 82077, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51432, 60),
      ))
    }

@delegate:ResourceContentHash(127_136_534)
public val Res.string.checklist_add_item: StringResource by lazy {
      StringResource("string:checklist_add_item", "checklist_add_item", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58842, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 82182, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51493, 38),
      ))
    }

@delegate:ResourceContentHash(-1_231_718_855)
public val Res.string.checklist_add_note: StringResource by lazy {
      StringResource("string:checklist_add_note", "checklist_add_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58889, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 82249, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51532, 38),
      ))
    }

@delegate:ResourceContentHash(-1_493_918_877)
public val Res.string.checklist_attach_days: StringResource by lazy {
      StringResource("string:checklist_attach_days", "checklist_attach_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59175, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 82659, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51774, 49),
      ))
    }

@delegate:ResourceContentHash(-1_627_219_430)
public val Res.string.checklist_attach_days_hint: StringResource by lazy {
      StringResource("string:checklist_attach_days_hint", "checklist_attach_days_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 58936, 238),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 82316, 342),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51571, 202),
      ))
    }

@delegate:ResourceContentHash(-2_092_099_155)
public val Res.string.checklist_attach_shifts: StringResource by lazy {
      StringResource("string:checklist_attach_shifts", "checklist_attach_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59217, 71),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 82709, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51824, 63),
      ))
    }

@delegate:ResourceContentHash(806_865_674)
public val Res.string.checklist_complete: StringResource by lazy {
      StringResource("string:checklist_complete", "checklist_complete", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59340, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 82856, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51935, 34),
      ))
    }

@delegate:ResourceContentHash(545_489_261)
public val Res.string.checklist_completed_at: StringResource by lazy {
      StringResource("string:checklist_completed_at", "checklist_completed_at", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59289, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 82793, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51888, 46),
      ))
    }

@delegate:ResourceContentHash(866_310_835)
public val Res.string.checklist_delete: StringResource by lazy {
      StringResource("string:checklist_delete", "checklist_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59546, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83154, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52125, 48),
      ))
    }

@delegate:ResourceContentHash(-35_936_579)
public val Res.string.checklist_delete_confirm: StringResource by lazy {
      StringResource("string:checklist_delete_confirm", "checklist_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59375, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 82907, 176),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 51970, 104),
      ))
    }

@delegate:ResourceContentHash(-313_395_768)
public val Res.string.checklist_deleted: StringResource by lazy {
      StringResource("string:checklist_deleted", "checklist_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59492, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83084, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52075, 49),
      ))
    }

@delegate:ResourceContentHash(-878_017_970)
public val Res.string.checklist_edit: StringResource by lazy {
      StringResource("string:checklist_edit", "checklist_edit", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59643, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83295, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52214, 42),
      ))
    }

@delegate:ResourceContentHash(-1_002_552_770)
public val Res.string.checklist_edit_note: StringResource by lazy {
      StringResource("string:checklist_edit_note", "checklist_edit_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59595, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83223, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52174, 39),
      ))
    }

@delegate:ResourceContentHash(567_256_330)
public val Res.string.checklist_item_label: StringResource by lazy {
      StringResource("string:checklist_item_label", "checklist_item_label", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59690, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83366, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52257, 40),
      ))
    }

@delegate:ResourceContentHash(423_845_211)
public val Res.string.checklist_item_needs_note: StringResource by lazy {
      StringResource("string:checklist_item_needs_note", "checklist_item_needs_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59735, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83423, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52298, 49),
      ))
    }

@delegate:ResourceContentHash(-1_494_345_877)
public val Res.string.checklist_items: StringResource by lazy {
      StringResource("string:checklist_items", "checklist_items", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59839, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83563, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52394, 31),
      ))
    }

@delegate:ResourceContentHash(-558_739_446)
public val Res.string.checklist_items_count: StringResource by lazy {
      StringResource("string:checklist_items_count", "checklist_items_count", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59789, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83501, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52348, 45),
      ))
    }

@delegate:ResourceContentHash(867_893_484)
public val Res.string.checklist_kind: StringResource by lazy {
      StringResource("string:checklist_kind", "checklist_kind", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60003, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83767, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52550, 30),
      ))
    }

@delegate:ResourceContentHash(-1_064_446_888)
public val Res.string.checklist_kind_closing: StringResource by lazy {
      StringResource("string:checklist_kind_closing", "checklist_kind_closing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59875, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83611, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52426, 42),
      ))
    }

@delegate:ResourceContentHash(1_709_570_227)
public val Res.string.checklist_kind_custom: StringResource by lazy {
      StringResource("string:checklist_kind_custom", "checklist_kind_custom", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59922, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83666, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52469, 37),
      ))
    }

@delegate:ResourceContentHash(1_035_745_897)
public val Res.string.checklist_kind_opening: StringResource by lazy {
      StringResource("string:checklist_kind_opening", "checklist_kind_opening", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 59960, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83712, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52507, 42),
      ))
    }

@delegate:ResourceContentHash(1_524_709_883)
public val Res.string.checklist_name: StringResource by lazy {
      StringResource("string:checklist_name", "checklist_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60034, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83798, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52581, 30),
      ))
    }

@delegate:ResourceContentHash(-713_818_904)
public val Res.string.checklist_none_on_shift: StringResource by lazy {
      StringResource("string:checklist_none_on_shift", "checklist_none_on_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60065, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83837, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52612, 71),
      ))
    }

@delegate:ResourceContentHash(811_911_630)
public val Res.string.checklist_not_started: StringResource by lazy {
      StringResource("string:checklist_not_started", "checklist_not_started", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60133, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 83941, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52684, 45),
      ))
    }

@delegate:ResourceContentHash(-1_145_600_808)
public val Res.string.checklist_note: StringResource by lazy {
      StringResource("string:checklist_note", "checklist_note", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60251, 34),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 84111, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52794, 30),
      ))
    }

@delegate:ResourceContentHash(12_566_208)
public val Res.string.checklist_note_required: StringResource by lazy {
      StringResource("string:checklist_note_required", "checklist_note_required", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60183, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 84003, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52730, 63),
      ))
    }

@delegate:ResourceContentHash(1_765_077_554)
public val Res.string.checklist_on_days: StringResource by lazy {
      StringResource("string:checklist_on_days", "checklist_on_days", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60286, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 84158, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52825, 41),
      ))
    }

@delegate:ResourceContentHash(-1_354_811_800)
public val Res.string.checklist_on_shifts: StringResource by lazy {
      StringResource("string:checklist_on_shifts", "checklist_on_shifts", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60324, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 84200, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52867, 43),
      ))
    }

@delegate:ResourceContentHash(2_008_179_366)
public val Res.string.checklist_only_assignee: StringResource by lazy {
      StringResource("string:checklist_only_assignee", "checklist_only_assignee", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60368, 103),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 84252, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52911, 99),
      ))
    }

@delegate:ResourceContentHash(-141_424_981)
public val Res.string.checklist_problem_empty_item: StringResource by lazy {
      StringResource("string:checklist_problem_empty_item", "checklist_problem_empty_item", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60472, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 84420, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53011, 76),
      ))
    }

@delegate:ResourceContentHash(964_525_334)
public val Res.string.checklist_problem_no_items: StringResource by lazy {
      StringResource("string:checklist_problem_no_items", "checklist_problem_no_items", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60557, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 84545, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53088, 62),
      ))
    }

@delegate:ResourceContentHash(-512_802_924)
public val Res.string.checklist_problem_no_name: StringResource by lazy {
      StringResource("string:checklist_problem_no_name", "checklist_problem_no_name", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60636, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 84656, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53151, 69),
      ))
    }

@delegate:ResourceContentHash(-681_025_879)
public val Res.string.checklist_problem_not_attached: StringResource by lazy {
      StringResource("string:checklist_problem_not_attached", "checklist_problem_not_attached", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60706, 90),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 84738, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53221, 90),
      ))
    }

@delegate:ResourceContentHash(-1_417_191_865)
public val Res.string.checklist_problem_too_long: StringResource by lazy {
      StringResource("string:checklist_problem_too_long", "checklist_problem_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60797, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 84861, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53312, 74),
      ))
    }

@delegate:ResourceContentHash(581_271_567)
public val Res.string.checklist_problem_too_many: StringResource by lazy {
      StringResource("string:checklist_problem_too_many", "checklist_problem_too_many", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60868, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 84964, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53387, 58),
      ))
    }

@delegate:ResourceContentHash(1_354_417_924)
public val Res.string.checklist_progress: StringResource by lazy {
      StringResource("string:checklist_progress", "checklist_progress", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60931, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 85083, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53446, 46),
      ))
    }

@delegate:ResourceContentHash(-878_912_005)
public val Res.string.checklist_remove_item: StringResource by lazy {
      StringResource("string:checklist_remove_item", "checklist_remove_item", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 60986, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 85146, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53493, 45),
      ))
    }

@delegate:ResourceContentHash(2_074_715_664)
public val Res.string.checklist_saved: StringResource by lazy {
      StringResource("string:checklist_saved", "checklist_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61036, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 85220, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53539, 43),
      ))
    }

@delegate:ResourceContentHash(-987_479_231)
public val Res.string.checklist_shift_line: StringResource by lazy {
      StringResource("string:checklist_shift_line", "checklist_shift_line", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61088, 52),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 85292, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53583, 52),
      ))
    }

@delegate:ResourceContentHash(-2_010_191_900)
public val Res.string.checklist_skipped_on_tablet: StringResource by lazy {
      StringResource("string:checklist_skipped_on_tablet", "checklist_skipped_on_tablet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61220, 67),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 85448, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53715, 63),
      ))
    }

@delegate:ResourceContentHash(2_088_986_941)
public val Res.string.checklist_skipped_on_tablet_at: StringResource by lazy {
      StringResource("string:checklist_skipped_on_tablet_at", "checklist_skipped_on_tablet_at", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61141, 78),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 85345, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53636, 78),
      ))
    }

@delegate:ResourceContentHash(-494_182_013)
public val Res.string.checklists_day_empty: StringResource by lazy {
      StringResource("string:checklists_day_empty", "checklists_day_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61288, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 85540, 96),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53779, 64),
      ))
    }

@delegate:ResourceContentHash(458_414_849)
public val Res.string.checklists_new: StringResource by lazy {
      StringResource("string:checklists_new", "checklists_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61353, 42),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 85637, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53844, 42),
      ))
    }

@delegate:ResourceContentHash(546_109_141)
public val Res.string.checklists_next_day: StringResource by lazy {
      StringResource("string:checklists_next_day", "checklists_next_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61396, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 85696, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53887, 39),
      ))
    }

@delegate:ResourceContentHash(-1_893_988_414)
public val Res.string.checklists_previous_day: StringResource by lazy {
      StringResource("string:checklists_previous_day", "checklists_previous_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61448, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 85760, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53927, 47),
      ))
    }

@delegate:ResourceContentHash(-1_091_169_964)
public val Res.string.checklists_tab_day: StringResource by lazy {
      StringResource("string:checklists_tab_day", "checklists_tab_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 61504, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 85832, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 53975, 34),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString6Resources(map: MutableMap<String, StringResource>) {
  map.put("capacity_col_planned", Res.string.capacity_col_planned)
  map.put("capacity_col_target", Res.string.capacity_col_target)
  map.put("capacity_days", Res.string.capacity_days)
  map.put("capacity_demand", Res.string.capacity_demand)
  map.put("capacity_demand_detail", Res.string.capacity_demand_detail)
  map.put("capacity_everyone_answered", Res.string.capacity_everyone_answered)
  map.put("capacity_excluded", Res.string.capacity_excluded)
  map.put("capacity_excluded_detail", Res.string.capacity_excluded_detail)
  map.put("capacity_excluded_employment", Res.string.capacity_excluded_employment)
  map.put("capacity_excluded_owner", Res.string.capacity_excluded_owner)
  map.put("capacity_gap", Res.string.capacity_gap)
  map.put("capacity_gap_even", Res.string.capacity_gap_even)
  map.put("capacity_gap_short", Res.string.capacity_gap_short)
  map.put("capacity_gap_spare", Res.string.capacity_gap_spare)
  map.put("capacity_hours", Res.string.capacity_hours)
  map.put("capacity_how", Res.string.capacity_how)
  map.put("capacity_missing_title", Res.string.capacity_missing_title)
  map.put("capacity_no_request", Res.string.capacity_no_request)
  map.put("capacity_norm", Res.string.capacity_norm)
  map.put("capacity_norm_detail", Res.string.capacity_norm_detail)
  map.put("capacity_people", Res.string.capacity_people)
  map.put("capacity_person_absent", Res.string.capacity_person_absent)
  map.put("capacity_person_available", Res.string.capacity_person_available)
  map.put("capacity_person_no_target", Res.string.capacity_person_no_target)
  map.put("capacity_person_planned", Res.string.capacity_person_planned)
  map.put("capacity_person_target", Res.string.capacity_person_target)
  map.put("capacity_person_target_month", Res.string.capacity_person_target_month)
  map.put("capacity_remind", Res.string.capacity_remind)
  map.put("capacity_reminder_message", Res.string.capacity_reminder_message)
  map.put("capacity_reminder_message_due", Res.string.capacity_reminder_message_due)
  map.put("capacity_reminder_title", Res.string.capacity_reminder_title)
  map.put("capacity_reminders_sent", Res.string.capacity_reminders_sent)
  map.put("capacity_request_days", Res.string.capacity_request_days)
  map.put("capacity_targets", Res.string.capacity_targets)
  map.put("capacity_targets_detail", Res.string.capacity_targets_detail)
  map.put("capacity_title", Res.string.capacity_title)
  map.put("capacity_whole_month", Res.string.capacity_whole_month)
  map.put("care_counter_child", Res.string.care_counter_child)
  map.put("care_counter_family", Res.string.care_counter_family)
  map.put("care_counter_total", Res.string.care_counter_total)
  map.put("care_for_child", Res.string.care_for_child)
  map.put("care_for_family", Res.string.care_for_family)
  map.put("care_for_label", Res.string.care_for_label)
  map.put("chart_full_size_title", Res.string.chart_full_size_title)
  map.put("chart_hours_planned", Res.string.chart_hours_planned)
  map.put("chart_hours_title", Res.string.chart_hours_title)
  map.put("chart_hours_worked", Res.string.chart_hours_worked)
  map.put("chart_labor_cost", Res.string.chart_labor_cost)
  map.put("chart_labor_share", Res.string.chart_labor_share)
  map.put("chart_labor_share_income", Res.string.chart_labor_share_income)
  map.put("chart_labor_trend_title", Res.string.chart_labor_trend_title)
  map.put("chart_plan_suffix", Res.string.chart_plan_suffix)
  map.put("chart_revenue", Res.string.chart_revenue)
  map.put("chart_revenue_labor_title", Res.string.chart_revenue_labor_title)
  map.put("chart_show_full_size", Res.string.chart_show_full_size)
  map.put("checklist_add_item", Res.string.checklist_add_item)
  map.put("checklist_add_note", Res.string.checklist_add_note)
  map.put("checklist_attach_days", Res.string.checklist_attach_days)
  map.put("checklist_attach_days_hint", Res.string.checklist_attach_days_hint)
  map.put("checklist_attach_shifts", Res.string.checklist_attach_shifts)
  map.put("checklist_complete", Res.string.checklist_complete)
  map.put("checklist_completed_at", Res.string.checklist_completed_at)
  map.put("checklist_delete", Res.string.checklist_delete)
  map.put("checklist_delete_confirm", Res.string.checklist_delete_confirm)
  map.put("checklist_deleted", Res.string.checklist_deleted)
  map.put("checklist_edit", Res.string.checklist_edit)
  map.put("checklist_edit_note", Res.string.checklist_edit_note)
  map.put("checklist_item_label", Res.string.checklist_item_label)
  map.put("checklist_item_needs_note", Res.string.checklist_item_needs_note)
  map.put("checklist_items", Res.string.checklist_items)
  map.put("checklist_items_count", Res.string.checklist_items_count)
  map.put("checklist_kind", Res.string.checklist_kind)
  map.put("checklist_kind_closing", Res.string.checklist_kind_closing)
  map.put("checklist_kind_custom", Res.string.checklist_kind_custom)
  map.put("checklist_kind_opening", Res.string.checklist_kind_opening)
  map.put("checklist_name", Res.string.checklist_name)
  map.put("checklist_none_on_shift", Res.string.checklist_none_on_shift)
  map.put("checklist_not_started", Res.string.checklist_not_started)
  map.put("checklist_note", Res.string.checklist_note)
  map.put("checklist_note_required", Res.string.checklist_note_required)
  map.put("checklist_on_days", Res.string.checklist_on_days)
  map.put("checklist_on_shifts", Res.string.checklist_on_shifts)
  map.put("checklist_only_assignee", Res.string.checklist_only_assignee)
  map.put("checklist_problem_empty_item", Res.string.checklist_problem_empty_item)
  map.put("checklist_problem_no_items", Res.string.checklist_problem_no_items)
  map.put("checklist_problem_no_name", Res.string.checklist_problem_no_name)
  map.put("checklist_problem_not_attached", Res.string.checklist_problem_not_attached)
  map.put("checklist_problem_too_long", Res.string.checklist_problem_too_long)
  map.put("checklist_problem_too_many", Res.string.checklist_problem_too_many)
  map.put("checklist_progress", Res.string.checklist_progress)
  map.put("checklist_remove_item", Res.string.checklist_remove_item)
  map.put("checklist_saved", Res.string.checklist_saved)
  map.put("checklist_shift_line", Res.string.checklist_shift_line)
  map.put("checklist_skipped_on_tablet", Res.string.checklist_skipped_on_tablet)
  map.put("checklist_skipped_on_tablet_at", Res.string.checklist_skipped_on_tablet_at)
  map.put("checklists_day_empty", Res.string.checklists_day_empty)
  map.put("checklists_new", Res.string.checklists_new)
  map.put("checklists_next_day", Res.string.checklists_next_day)
  map.put("checklists_previous_day", Res.string.checklists_previous_day)
  map.put("checklists_tab_day", Res.string.checklists_tab_day)
}
